import "../styles/template.css";
import { MdMore, MdSpaceDashboard } from "react-icons/md";
import { FaStore } from "react-icons/fa";
import { GiMiner } from "react-icons/gi";
import { IoIosPeople } from "react-icons/io";
import { MdMenuBook } from "react-icons/md";
import { RiBankFill } from "react-icons/ri";

import { RiDashboardFill } from "react-icons/ri";
import { IoStorefrontSharp } from "react-icons/io5";
import Narbar from "../components/narbar/Narbar";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { dropStore } from "../slice/storeSlice";
import { dropUser } from "../slice/webStoreUserSlice";
import { clearCart } from "../slice/sellingCarts";
import { dropWarehouse } from "../slice/warehouseSlice";
import { dropSelectedMessage } from "../slice/MessageSlice";
import { BiArrowToLeft } from "react-icons/bi";
import { emptyQueue } from "../slice/offlineQueue";
import { syncOfflineQueue } from "../tools/synOfflineQueue";
import { deleteDB } from "../tools/indexdb";
import { useIdelHandler } from "../tools/sessionHandler.js";
import { uiAlert } from "../components/alerts/customAlert/uiAlert.js";
import { Box, MoreHorizontal, Receipt } from "lucide-react";
import { useState, useEffect } from "react";

/* const SocketContext = createContext(null);
export const useSocket = () => useContext(SocketContext); */

const Template = (props) => {
  // creating a socket connection to the server
  /* const [showAd, setShowAd] = useState(true); */
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { count, _ } = useSelector((state) => state.offlineQueue);
  const { user } = useSelector((state) => state.webStoreUser);
  const [synchronizing, setSynchronizing] = useState(false);

  const handleClick = (e, path) => {
    console.log(path);

    if (user.userIsSubscribed && user.freeTrial) {
      navigate(path);
      return;
    }

    if (!user?.userIsSubscribed) {
      if (path !== "/settings/profile" && path !== "/mystores") {
        uiAlert("You don't have a subscription plan yet. Please renew/create a subscription to access this feature.", "warning");
        return;
      }
    } else if (user?.userType.userType.toLowerCase().includes("starter")) {
      if (path !== "/settings/profile" && path !== "/mystores") {
        uiAlert("Your current plan does not allow access to this feature. Please upgrade your plan to access this feature.");
        return;
      }
    }

    navigate(path);
  };

  const signOut = async () => {
    if (count) {
      console.log(count, "signing out");
      setSynchronizing(true);
      await syncOfflineQueue();
      setSynchronizing(false);
    }
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");

    // if its a react Native webview
    if (window.ReactNativeWebView) {
      try {
        dispatch(dropStore());
        dispatch(clearCart());
        dispatch(dropWarehouse());
        dispatch(dropSelectedMessage());
        dispatch(emptyQueue());
        deleteDB();
        window.ReactNativeWebView.postMessage(JSON.stringify({ type: "LOG_OUT" }));
      } catch (error) {
        console.log("error signing out from react native app", error);
      }
    } else {
      navigate("/sign-in");
      dispatch(dropStore());
      dispatch(clearCart());
      dispatch(dropWarehouse());
      dispatch(dropSelectedMessage());
      dispatch(dropUser());
      dispatch(emptyQueue());
      deleteDB();
    }
  };
  useIdelHandler(signOut, 1000 * 60 * 60 * 5); // 5 hours idle time before signing out

  return (
    <>
      {synchronizing && <SyncingOverlay itemCount={count} />}
      <Narbar />
      <div className='TemplateContain'>
        <div className='templateWrapper'>
          <div>
            <div>
              <div
                onClick={() => {
                  navigate("/settings/referral");
                }}
                className='StorePlaceholder'
              >
                <img
                  src={"https://res.cloudinary.com/ebuka1122/image/upload/v1766017964/static%20images%20storelens/Adlandscape_cvxnhf.webp"}
                  alt='Company Ad'
                />
                {/*  <img src='https://www.shutterstock.com/shutterstock/photos/134384900/display_1500/stock-photo--d-your-ad-here-button-click-here-block-text-over-white-background-134384900.jpg' /> */}
              </div>
              <div className={"sideMenu"}>
                <div className={location.pathname.includes("/dashboard") ? "clickedOption" : ""} onClick={(e) => handleClick(e, "/dashboard")}>
                  <MdSpaceDashboard size={22} />

                  <span>Dashboard</span>
                </div>
                <div
                  className={location.pathname.includes("/mystores") ? "clickedOption" : ""}
                  onClick={(e) => {
                    handleClick(e, "/mystores");
                    dispatch(dropStore());
                    dispatch(clearCart());
                    dispatch(dropWarehouse());
                    dispatch(dropSelectedMessage());
                  }}
                >
                  <FaStore size={20} />
                  <span>Stores</span>
                </div>
                <div className={location.pathname === "/product-catelogue" ? "clickedOption" : ""} onClick={(e) => handleClick(e, "/product-catelogue")}>
                  <Box size={22} />
                  <span>Product Catalogue</span>
                </div>
                <div className={location.pathname === "/transactions" ? "clickedOption" : ""} onClick={(e) => handleClick(e, "/transactions")}>
                  <Receipt size={22} />
                  <span>Transactions</span>
                </div>

                <div className={location.pathname === "/employees" ? "clickedOption" : ""} onClick={(e) => handleClick(e, "/employees")}>
                  <GiMiner size={22} />
                  <span>Employees</span>
                </div>
                <div className={location.pathname === "/customers" ? "clickedOption" : ""} onClick={(e) => handleClick(e, "/customers")}>
                  <IoIosPeople size={22} />
                  <span>Customers</span>
                </div>
                <div className={location.pathname === "/sales-record" ? "clickedOption" : ""} onClick={(e) => handleClick(e, "/sales-record")}>
                  <MdMenuBook size={20} />
                  <span>Sales record</span>
                </div>
                <div className={location.pathname === "/more" ? "clickedOption" : ""} onClick={(e) => handleClick(e, "/more")}>
                  <MoreHorizontal size={20} />
                  <span>More</span>
                </div>
                {/*  <div className={location.pathname === "/payout" ? "clickedOption" : ""} onClick={(e) => handleClick(e, "/payout")}>
                  <RiBankFill size={20} />
                  <span>Payouts</span>
                </div> */}
              </div>
            </div>
            <div className='signOutDiv'>
              <div></div>
              <div onClick={() => signOut()}>
                <BiArrowToLeft size={20} />
                <span>Sign out</span>
              </div>
            </div>
          </div>
          <div>{props.children}</div>
          {/* <SocketContext.Provider value={userSocket}>{props.children}</SocketContext.Provider> */}
        </div>
      </div>
    </>
  );
};

export default Template;

/* ═══════════════════════════════════════════════
   SYNC OVERLAY  —  SyncingOverlay.jsx

   Full-screen "atom" animation shown while the offline
   queue is being flushed (e.g. on logout, if count > 0).

   Usage:
     const [synchronizing, setSynchronizing] = useState(false);
     const { count } = useSelector((state) => state.offlineQueue);

     const handleLogout = async () => {
       if (count) {
         setSynchronizing(true);
         await syncOfflineQueue();
         setSynchronizing(false);
       }
       // ...proceed with logout
     };

     return (
       <>
         {synchronizing && <SyncingOverlay itemCount={count} />}
         ...rest of your UI
       </>
     );
═══════════════════════════════════════════════ */

const SYNC_ANIM_CSS = `
.sync-overlay-root {
  position: fixed;
  inset: 0;
  z-index: 99999;
  background: rgba(15, 42, 71, 0.94);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 22px;
  animation: syncFadeIn 0.25s ease;
  font-family: 'Nunito', sans-serif;
  padding: 24px;
  text-align: center;
}
@keyframes syncFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.sync-atom-wrap {
  position: relative;
  width: 110px;
  height: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sync-atom-nucleus {
  position: relative;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #37b4c5;
  box-shadow: 0 0 18px 4px rgba(55, 180, 197, 0.65);
  z-index: 2;
  animation: syncPulse 1.4s ease-in-out infinite;
}
@keyframes syncPulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.25); }
}

.sync-orbit {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1.5px solid rgba(255, 255, 255, 0.25);
  border-radius: 50%;
}
.sync-orbit-1 { animation: syncSpin 2.2s linear infinite; }
.sync-orbit-2 { transform: rotate(60deg); animation: syncSpin 2.6s linear infinite reverse; }
.sync-orbit-3 { transform: rotate(120deg); animation: syncSpin 3.1s linear infinite; }
@keyframes syncSpin {
  to { transform: rotate(360deg); }
}

.sync-electron {
  position: absolute;
  top: -4px;
  left: 50%;
  width: 8px;
  height: 8px;
  margin-left: -4px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 0 8px 2px rgba(255, 255, 255, 0.8);
}

.sync-title {
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
}

.sync-subtitle {
  color: rgba(255, 255, 255, 0.65);
  font-size: 13px;
  max-width: 300px;
  line-height: 1.5;
}

.sync-progress-track {
  width: 200px;
  height: 4px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.15);
  overflow: hidden;
}

.sync-progress-fill {
  height: 100%;
  width: 35%;
  border-radius: 4px;
  background: linear-gradient(90deg, #37b4c5, #1d6fd8);
  animation: syncProgress 1.3s ease-in-out infinite;
}
@keyframes syncProgress {
  0% { transform: translateX(-120%); }
  100% { transform: translateX(400%); }
}

@media (prefers-reduced-motion: reduce) {
  .sync-atom-nucleus,
  .sync-orbit-1,
  .sync-orbit-2,
  .sync-orbit-3,
  .sync-progress-fill {
    animation: none;
  }
}
`;

/**
 * SyncingOverlay
 *
 * Blocking full-screen overlay with an "atom" animation (a pulsing
 * nucleus with three orbiting electrons) shown while offline-queued
 * changes are being synced — typically right before completing a
 * logout so the queue doesn't get silently dropped.
 *
 * Props:
 * - itemCount: number — how many queued items are being synced (optional,
 *   just changes the subtitle copy)
 * - title / subtitle: optional copy overrides
 */
export const SyncingOverlay = ({ itemCount, title, subtitle }) => {
  // Block background scroll/interaction for as long as this is mounted.
  useEffect(() => {
    const original = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = original;
    };
  }, []);

  const defaultSubtitle =
    itemCount > 0
      ? `Finishing up ${itemCount} item${itemCount === 1 ? "" : "s"} saved while you were offline. Make sure there is stable internet connection. Please don't close the app.`
      : "Please don't close the app.";

  return (
    <>
      <style>{SYNC_ANIM_CSS}</style>
      <div className='sync-overlay-root' role='status' aria-live='polite'>
        <div className='sync-atom-wrap'>
          <div className='sync-orbit sync-orbit-1'>
            <div className='sync-electron' />
          </div>
          <div className='sync-orbit sync-orbit-2'>
            <div className='sync-electron' />
          </div>
          <div className='sync-orbit sync-orbit-3'>
            <div className='sync-electron' />
          </div>
          <div className='sync-atom-nucleus' />
        </div>
        <div className='sync-title'>{title || "Syncing offline changes…"}</div>
        <div className='sync-subtitle'>{subtitle || defaultSubtitle}</div>
        <div className='sync-progress-track'>
          <div className='sync-progress-fill' />
        </div>
      </div>
    </>
  );
};
